angular.module('cfn').factory('BookingOperations', [
  '$resource',
  function($resource) {
    return $resource(
      '/365FarmNet/rest/booking/operations/:restAction:id',
      {},
      {
        load: { method: 'GET', params: { id: '@id' } },
        save: { method: 'POST' },
        query: { method: 'GET', isArray: true },
        delete: { method: 'DELETE', params: { id: '@id' } },
        create: { method: 'PUT' },
        call: { method: 'POST', params: { restAction: '@restAction' } },
        Credentials: { method: 'GET', params: { restAction: 'Credentials' } }
      }
    );
  }
]);
